import { useState, useEffect } from "react";
import { words } from "../data";
import { formatNumDecimalPoint } from "../helpers";

export default function useTypewriter(difficulty, time, setTime) {
  const randomIndex = Math.floor(Math.random() * words.length);
  const [startedTyping, setStartedTyping] = useState(false),
    [currentWord, setCurrentWord] = useState(words[randomIndex]),
    [value, setValue] = useState(""),
    [score, setScore] = useState(0),
    [success, setSuccess] = useState(""),
    [displayRestart, setDisplayRestart] = useState(false),
    [restart, setRestart] = useState();
  useEffect(() => {
    // Resets the timer, nullifies or increases the score accordingly, displays the success message (optional)
    function reset(newScore, message = false, hideRestart = true) {
      setTime(formatNumDecimalPoint(difficulty.limit, 2));
      setScore(newScore);
      setCurrentWord(words[randomIndex]);
      setValue("");
      message && setSuccess("Success!");
      hideRestart && setDisplayRestart(false);
      hideRestart && setRestart(false);
    }
    // Function to call inside setInterval
    function countdown() {
      if (time > 0.0 && startedTyping) {
        setTime(formatNumDecimalPoint(time - 0.01, 2));
        if (value === currentWord + " ") {
          reset(score + difficulty.points, true, false);
        }
      } else if (time > 0.0 && !startedTyping) {
        setSuccess("");
      } else {
        setStartedTyping(false);
        setSuccess("Failed");
        setDisplayRestart(true);
      }
    }
    // Reset on restart
    restart && reset(0);
    const interval = setInterval(countdown, 10);
    return () => clearInterval(interval);
  }, [
    time,
    setTime,
    startedTyping,
    setStartedTyping,
    difficulty,
    value,
    currentWord,
    score,
    randomIndex,
    success,
    displayRestart,
    restart,
  ]);
  return {
    time,
    difficulty,
    value,
    setValue,
    setStartedTyping,
    currentWord,
    score,
    success,
    displayRestart,
    setRestart,
  };
}
